// Generated by GitHub Copilot
import { CompanyTimestampedModel } from '#core/entities/shared/BaseModels.ts'
import { Transform, Type } from 'class-transformer'
import { Permission } from '#core/entities/auth/roles/Permission'

/** Invitation status as returned by the backend. */
export type CompanyInvitationStatus = 'pending' | 'accepted' | 'revoked' | 'expired'

/** Company invitation record returned by `GET /auth/company-invitations/`. */
export default class CompanyInvitation extends CompanyTimestampedModel {
  email: string = ''
  invited_user_id: string | null = null
  role_id: string | null = null
  role_name: string | null = null
  @Type(() => Permission)
  personal_permissions: Permission[] | null = null
  invited_by_user_id: string | null = null
  // The backend serializes the status enum uppercase (e.g. "PENDING"); normalize to the
  // lowercase union the UI compares against.
  @Transform(({ value }) => (typeof value === 'string' ? value.toLowerCase() : value))
  status: CompanyInvitationStatus = 'pending'
  @Type(() => Date)
  expires_at: Date | null = null
  @Type(() => Date)
  accepted_at: Date | null = null
  @Type(() => Date)
  revoked_at: Date | null = null
}
